import { render } from "./client-subclients.vue?vue&type=template&id=c19d1cae"
import script from "./client-subclients.vue?vue&type=script&lang=js"
export * from "./client-subclients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__